import { defineStore } from 'pinia';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { strapi } from '../transport/strapi';
import type { IWheelStrapiItem } from '~/types/wheel';

export const useStoreFortuneWheel = defineStore('fortuneWheel', {
  state: () => ({
    title: '',
    modalPrizeCongratsText: '',
    modalPrizeYouWinText: '',
    modalPrizeBtnTakeBonus: '',
    modalPrizeBtnSpinAgain: '',
    wheeltems: [] as IWheelStrapiItem[],
    isLoaded: false,
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadFortuneWheel() {
      if (!this.requestPromise) {
        const populateString = createPopulateString(['wheeltems', 'wheeltems.image']);

        this.requestPromise = strapi()
          .get('fortune-wheel-page', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);
        this.isLoaded = true;
        return true;
      } else {
        return false;
      }
    },
  },
});
